import React from 'react'
import { Container, Form, FormButton, FormContainer, FormH1, FormInput, FormLabel, FormWrap, Icon, Text } from './SigninElements'

const SignIn = () => {
    return (
        <>
            <Container>
                <FormWrap>
                    <Icon to='/'>LearnITSkills</Icon>
                    <FormContainer>
                        <Form action="#">
                            <FormH1>Sign in to your account </FormH1>
                            <FormLabel htmlFor='for'>Email</FormLabel>
                            <FormInput type='email' required />
                            <FormLabel htmlFor='for'>Password</FormLabel>
                            <FormInput type='password' required />
                            <FormButton htmlFor='for'>Continue</FormButton>
                            <Text>Forgot Password</Text>
                        </Form>
                    </FormContainer>
                </FormWrap>
            </Container>
        </>
    )
}

export default SignIn